import { initJoinForms } from "./join-form";

export function initPublicArticleRelatedStories() {
  document.querySelectorAll("[public-article-related-stories]").forEach((element) => {
    loadRelatedStoriesIn(element as HTMLElement);
  });
}

function loadRelatedStoriesIn(element: HTMLElement) {
  const articleID = element.getAttribute("public-article-related-stories");
  if (!articleID) {
    console.error("articleID must be provided for public-article-related-stories");
    return;
  }

  fetch(`/news/${articleID}/related`, {
    method: "GET",
    headers: {
      "Content-Type": "text/html; charset=utf-8",
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        return Promise.reject(response);
      }
    })
    .then((html) => {
      element.innerHTML = html;

      initJoinForms();
    })
    .catch((error) => {
      console.error("Error loading related articles", error);
    });
}

document.addEventListener("DOMContentLoaded", initPublicArticleRelatedStories);
